import api from './api';

const usuarioService = {
  atualizar: async (id, dados) => {
    const response = await api.put(`/usuarios/${id}`, dados);
    return response.data;
  },
};

export default usuarioService;
